module.exports = __webpack_public_path__ + "static/media/all-the-data.c64f8dc0.svg";